export const VENDA_MAIS_LOAD_CART = "VENDA_MAIS_LOAD_CART";
export const VENDA_MAIS_SAVE_CART = "VENDA_MAIS_SAVE_CART";
export const VENDA_MAIS_LOAD_PRICE = "VENDA_MAIS_LOAD_PRICE";
export const VENDA_MAIS_COORDENADAS = "VENDA_MAIS_COORDENADAS";
export const VENDA_MAIS_FORMAS_ENTREGA = "VENDA_MAIS_FORMAS_ENTREGA";
export const VENDA_MAIS_ENVIAR = "VENDA_MAIS_ENVIAR";
export const VENDA_MAIS_VALIDAR_CUPOM = "VENDA_MAIS_VALIDAR_CUPOM";
export const VENDA_MAIS_LOAD_PRODUTO = "VENDA_MAIS_LOAD_PRODUTO";
export const VENDA_MAIS_LOAD_CLIENTE = "VENDA_MAIS_LOAD_CLIENTE";
export const VENDA_MAIS_PRODUTOS_COPIA = "VENDA_MAIS_PRODUTOS_COPIA";
